import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from 'react-scale/components/design-system/styles';

interface IExampleHeaderProps {
  exampleType: string;
  disabled: boolean;
  readOnly: boolean; // this is different than disabled since disabled is also set on save
  setExampleType: (arg: string) => void;
}

const ExampleHeader: React.FC<IExampleHeaderProps> = ({
  exampleType,
  disabled,
  setExampleType,
  readOnly,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.exampleTypeSelector}>
        {(!readOnly || exampleType === 'good') && (
          <div
            className={classNames(classes.exampleType, {
              [classes.exampleTypeClickable]: !disabled,
            })}
            onClick={() => !disabled && setExampleType('good')}
            style={exampleType === 'good' ? { border: '1px solid green' } : {}}
          >
            <FontAwesomeIcon
              icon="check-circle"
              color="green"
              style={{ fontSize: '11px', lineHeight: '16px', marginRight: 8, opacity: 0.5 }}
            />
            Well labeled example
          </div>
        )}
        {(!readOnly || exampleType === 'bad') && (
          <div
            className={classNames(classes.exampleType, {
              [classes.exampleTypeClickable]: !disabled,
            })}
            onClick={() => !disabled && setExampleType('bad')}
            style={exampleType === 'bad' ? { border: '1px solid red' } : {}}
          >
            <FontAwesomeIcon
              icon="times-circle"
              color="red"
              style={{ fontSize: '11px', lineHeight: '16px', marginRight: 8, opacity: 0.3 }}
            />
            Poorly labeled example
          </div>
        )}
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flexFlow: 'column nowrap',
    flexWrap: 'nowrap',
  },
  exampleTypeSelector: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '12px',
  },
  exampleType: {
    margin: '8px',
    padding: '2px 8px 2px 8px',
    border: '1px solid #E6E6E6',
    borderRadius: '8px',
  },
  exampleTypeClickable: {
    cursor: 'pointer',
  },
});

export default ExampleHeader;
